import React from 'react';
import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useLanguage } from '@/contexts/LanguageContext';

// Slim banner shown at the top of the app when the device is offline.
// Does not block UI — users can still navigate and queue actions.
const NetworkBanner: React.FC = () => {
  const { connected } = useNetworkStatus();
  const { t } = useLanguage();

  if (connected) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 bg-destructive px-4 py-2 text-destructive-foreground text-sm font-medium shadow-md"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{t('network.offline') || 'No internet connection — working offline'}</span>
    </div>
  );
};

export default NetworkBanner;
